import {
  Component,
  HostBinding,
  Input,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector     : 'nz-breadcrumb',
  encapsulation: ViewEncapsulation.None,
  template     : `
    <ng-content></ng-content>`,
  styles: [
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-breadcrumb {
  color: #666;
  font-size: 14px;
}
.ant-breadcrumb a {
  color: #666;
  transition: color .3s;
}
.ant-breadcrumb a:hover {
  color: #3dc9be;
}
.ant-breadcrumb > span:last-child {
  font-weight: bold;
  color: #666;
}
.ant-breadcrumb > span:last-child .ant-breadcrumb-separator {
  display: none;
}
.ant-breadcrumb-separator {
  margin: 0 8px;
  color: rgba(0, 0, 0, 0.3);
}
.ant-breadcrumb-link > .anticon + span {
  margin-left: 4px;
}
`,
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-breadcrumb {
  color: #666;
  font-size: 14px;
}
.ant-breadcrumb a {
  color: #666;
  transition: color .3s;
}
.ant-breadcrumb a:hover {
  color: #3dc9be;
}
.ant-breadcrumb > span:last-child {
  font-weight: bold;
  color: #666;
}
.ant-breadcrumb > span:last-child .ant-breadcrumb-separator {
  display: none;
}
.ant-breadcrumb-separator {
  margin: 0 8px;
  color: rgba(0, 0, 0, 0.3);
}
.ant-breadcrumb-link > .anticon + span {
  margin-left: 4px;
}
.ant-breadcrumb {
  display: block;
}
.ant-breadcrumb > nz-breadcrumb-item:last-child {
  font-weight: bold;
  color: #666;
}
.ant-breadcrumb > nz-breadcrumb-item:last-child .ant-breadcrumb-separator {
  display: none;
}
`
  ],
  host: {
    '[class.ant-breadcrumb]': 'true'
  }
})
export class NzBreadCrumbComponent {
  @Input() nzSeparator = '/';
}
